var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.frontUrl && _vm.frontUrl != ""
    ? _c("div", { class: _vm.$style.style }, [
        _c("div", { staticClass: "content" }, [
          _c("iframe", {
            attrs: {
              src: _vm.frontUrl,
              frameborder: "none",
              name: "long-iframe_" + _vm.ifid,
              scrolling: "yes",
              id: _vm.ifid,
              allow: "autoplay"
            },
            on: {
              onload: function($event) {
                _vm.onLoad()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer" })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }